import { SCREEN } from "helper/roleChecker/Screens";
import { lazy } from "react";
import pathRoutes from "routes/pathRoutes";

const MainPage = lazy(() => import("./Pages/Main"));
const DetailEvent = lazy(() => import("./Pages/DetailEvent"));
const DetailProgram = lazy(() => import("./Pages/DetailProgram"));

export const eventRoutes = [
  {
    page: MainPage,
    path: pathRoutes.event.parameter,
    screenCode: SCREEN.IP_020,
  },
  {
    page: DetailEvent,
    path: pathRoutes.event.eventDetail.parameter,
    screenCode: SCREEN.IP_020,
  },
  {
    page: DetailProgram,
    path: pathRoutes.event.programDetail.parameter,
    screenCode: SCREEN.IP_020,
  },
];
